import React from 'react';
import loaderImg from '../Assets/Images/Caduceus 512x512.gif';


const Loader = ({isLoading}) => {
  return (
    isLoading && 
    <div className="loader-overlay">
      <img src={loaderImg} alt="Loading..."  width={'200px'} height={'200px'}  />
    </div>
  );
};

export default Loader;
